'use client';

import { c as _c } from "react/compiler-runtime";
import ROUTES from '@lib/constants/routes';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import style from './NextLink.module.scss';
function NextLink(t0) {
  const $ = _c(34);
  const {
    activeFloor,
    activeFlat,
    bulk,
    activeQueue,
    flatId,
    isMobile
  } = t0;
  const {
    houseId,
    floorId,
    apartmentId,
    bulkId
  } = useParams();
  let t1;
  if ($[0] !== floorId || $[1] !== isMobile) {
    const getButtonText = () => {
      if (floorId && !isMobile) {
        return "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443";
      }
      if (floorId && isMobile) {
        return "\u0412\u044B\u0431\u0440\u0430\u0442\u044C";
      }
      return "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C";
    };
    t1 = (to, condition) => {
      if (condition) {
        return <Link href={to}><div className={style.nextButton}>{getButtonText()}</div></Link>;
      }
      return null;
    };
    $[0] = floorId;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderNextButton = t1;
  const t2 = `${ROUTES.flats.visual.root}/${activeQueue}`;
  const t3 = !houseId && activeQueue === 2;
  let t4;
  if ($[3] !== renderNextButton || $[4] !== t2 || $[5] !== t3) {
    t4 = renderNextButton(t2, t3);
    $[3] = renderNextButton;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${ROUTES.flats.visual.root}/${activeQueue}/9335`;
  const t6 = !houseId && activeQueue === 1;
  let t7;
  if ($[7] !== renderNextButton || $[8] !== t5 || $[9] !== t6) {
    t7 = renderNextButton(t5, t6);
    $[7] = renderNextButton;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `${ROUTES.flats.visual.root}/${houseId}/${bulk}`;
  let t9;
  if ($[11] !== bulk || $[12] !== bulkId || $[13] !== floorId || $[14] !== houseId) {
    t9 = !floorId && houseId && !bulkId && (bulk.toString() === "9758" || bulk.toString() === "10099" || bulk.toString() === "10100");
    $[11] = bulk;
    $[12] = bulkId;
    $[13] = floorId;
    $[14] = houseId;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== renderNextButton || $[17] !== t8 || $[18] !== t9) {
    t10 = renderNextButton(t8, t9);
    $[16] = renderNextButton;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = `${ROUTES.flats.visual.root}/${houseId}/${bulkId}/${activeFloor}`;
  const t12 = !floorId && activeFloor;
  let t13;
  if ($[20] !== renderNextButton || $[21] !== t11 || $[22] !== t12) {
    t13 = renderNextButton(t11, t12);
    $[20] = renderNextButton;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `/flat/${flatId}`;
  const t15 = floorId && !apartmentId && activeFlat !== null;
  let t16;
  if ($[24] !== renderNextButton || $[25] !== t14 || $[26] !== t15) {
    t16 = renderNextButton(t14, t15);
    $[24] = renderNextButton;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t10 || $[29] !== t13 || $[30] !== t16 || $[31] !== t4 || $[32] !== t7) {
    t17 = <>{t4}{t7}{t10}{t13}{t16}</>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t16;
    $[31] = t4;
    $[32] = t7;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
export default NextLink;